import { IPivotHeaderItems } from './IPivotHeaderItems';

const CompanyHeaderItems: IPivotHeaderItems = {
  processes: {
    headerText: 'Processes',
    iconName: 'ServerProcesses',
    requestedPermission: 'ProcessesList:View',
  },
  'company-information': {
    headerText: 'Company Information',
    iconName: 'Info',
  },
  'annual-filing-requirements': {
    headerText: 'Annual Filing Requirements',
    iconName: 'OpenFolderHorizontal',
    requestedPermission: 'AnnualFilingRequirements:View',
  },
  'fiscal-years': {
    headerText: 'Fiscal Year Summary',
    iconName: 'Calendar',
    requestedPermission: 'FiscalYearSummaryList:View',
  },
  'service-contacts': {
    headerText: 'Service Contacts',
    iconName: 'ContactCard',
  },
  documents: {
    headerText: 'Documents',
    iconName: 'TextDocument',
  },
};

export default CompanyHeaderItems;
